import { IconButton, Menu, MenuItem } from "@mui/material";
import React, { Fragment } from "react";
import { ExternalLink } from "../Link/ExternalLink";
import MenuIcon from "@mui/icons-material/Menu";
import { MenuMobileProps } from "./Header.inteface";
import Box from "@mui/material/Box";
import { LoginButtonContainer } from "../../containers/LoginButtonContainer";

export const MenuMobile: React.FC<MenuMobileProps> = ({
  hiddenItems,
  handleMenuOpen,
  isSmallScreen,
  anchorEl,
  handleMenuClose,
}: MenuMobileProps) => {
  return (
    <Fragment>
      {(!!hiddenItems.length || isSmallScreen) && (
        <IconButton
          color="inherit"
          aria-label="menu"
          onClick={handleMenuOpen}
          sx={{
            marginTop: isSmallScreen ? "" : "-10px",
            ...(isSmallScreen && {
              width: 50,
              height: 50,
            }),
          }}
        >
          <MenuIcon
            sx={{
              color: "#fff",
              fontSize: 50,
              fontWeight: 900,
            }}
          />
        </IconButton>
      )}

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            backgroundColor: isSmallScreen ? "#001737" : "#fff",
            left: 0,
            width: "100%",
          },
        }}
        className="menu-mobile"
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {hiddenItems.map((item) => (
          <ExternalLink key={item.label} target="_self" link={item.path}>
            <MenuItem sx={{ color: "#fff", width: "100%", li: { gap: 5 } }}>
              <IconButton
                sx={{
                  "& svg": {
                    fill: "#fff",
                  },
                }}
              >
                {item.icon}
              </IconButton>
              {item.label}
            </MenuItem>
          </ExternalLink>
        ))}
        <Box sx={{ display: "flex", justifyContent: "center", padding: 2 }}>
          <LoginButtonContainer />
        </Box>
      </Menu>
    </Fragment>
  );
};
